export const DELETE_PLC_SAFETY_ZONE_DEPENDENCY = 'DELETE_PLC_SAFETY_ZONE_DEPENDENCY';
export const DELETE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL = 'DELETE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL';
export const DELETE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED = 'DELETE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED';
